import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Loader from '../nav/Loader';

const baseResultsURL = "https://www.roadtonationals.com/api/men/homeawaysplit";

class HomeAway extends Component {
  constructor(props) {
      let data = [
        {name: 'Air Force', avgteam: '9.5', maxteam: '9.5', homeavg: '9.5', awayavg: '9.5', diff: '39.5' }
      ];
      let columns = [
        {Header: 'Team', accessor: 'team_name', Cell: props => <a href={'/results/teamsM/dashboard/'+this.getYear()+'/'+props.original.team_id}>{props.value}</a>},
        {Header: 'Season AVG', accessor: 'avgteam'},
        {Header: 'Season High', accessor: 'maxteam'},
        {Header: 'Home AVG', accessor: 'homeavg', Cell: props => <span>{props.value} ({props.original.counthome})</span>},
        {Header: 'Away AVG', accessor: 'awayavg', Cell: props => <span>{props.value} ({props.original.countaway})</span>},
        {Header: 'H/A Diff', accessor: 'diff', style: {fontWeight : 'bold'}},
      ];
      super(props);
      this.state = {
        data: data,
        cols: columns,
        numRows: 0,
        yearFilter: props.yearFilter,
        showLoader: true
      };
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
  }
  getYear() {
    return this.state.yearFilter;
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.yearFilter !== this.state.yearFilter) {
      this.getResults({
        "year": nextProps.yearFilter
      });
      this.setState({
        yearFilter : nextProps.yearFilter,
        showLoader: true
      });
    }
  }
  componentWillMount() {
    this.getResults({
      "year": this.state.yearFilter
    });
  }
  getResults(config) {
    var url = baseResultsURL + '/' + config.year + '/' + 0;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        var length = response.data.length;
        this.setState({
          data : response.data,
          numRows : length,
          showLoader: false
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  render() {
    if(!this.state.showLoader) {
      return (
        <div>
            <div className="row">
                <div className="small-12 columns">
                <ReactTable
                className="-striped -highlight"
                data={this.state.data}
                columns={this.state.cols}
                defaultSortMethod={this.defaultSortMethod}
                showPagination={false}
                defaultPageSize={this.state.numRows}
                pageSize={this.state.numRows}
                />
                <br />
                  <p className="note">*This chart displays team score averages for home and away meets. Numbers in "()" are the number of home or away meets used in the calculation.</p>
                </div>
            </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  }
}

export default HomeAway;



// WEBPACK FOOTER //
// ./src/components/allteams/HomeAway.js